export default {
    Metadata: {
        Name: "IsDate",
        Description: "Returns true if the value is a Date, otherwise false.",
        Syntax: "IsDate(value)",
        Keywords: ['Date'],
        Author: "DataVoke, Inc.",
    },
    execute(value) {
        switch (value) {
            case "Null":
            case "True":
            case "False":
            case "":
            case null:
            case true:
            case false:
                return false;
        }

        if (typeof value == "undefined") {
            return false;
        }

        var validatedObj = app.dv.tools.validateValue(app.dv.types.PropertyDataType.DateTime, value);
        return validatedObj.response;
    },
};

